module.exports = __webpack_public_path__ + "static/img/ic_success.20d6b88f.png";